
import * as React from 'react';

interface IFrameProps {
	className?: string;
	content: string;
}

interface IFrameState {
	
}

export default class Frame extends React.Component<IFrameProps, IFrameState>{

	comp: HTMLIFrameElement;

	componentDidMount() {
		if (!!this.comp) {
			
			this.comp.onkeydown = this.disableKeys;
			this.comp.onkeypress = this.disableKeys;
			this.comp.onkeyup = this.disableKeys;

		}
	}
	

	disableKeys = () => {
		if (this.comp) {

			this.comp.blur();
		}
	}

	public setContent = (content: string) => {
		if (this.comp) {
			this.comp.contentDocument.open();
			this.comp.contentDocument.write(this.props.content);
			this.comp.contentDocument.close();
		}
	}

	render() {
		return <iframe className={this.props.className} ref={e => this.comp = e} />;
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/richtextview/frame.tsx